import { useState } from 'react';

import { ArtifactType } from '@/shared/types';

import { saveFileFromBlob } from '../helpers/saveFileFromBlob';

import type { ResponseArtifact } from '@/api/types';

interface HookReturn {
  isArtifactLoading: boolean;
  currentArtifactTypeLoading: Nullable<ArtifactType>;
  currentArtifactExtendLoading: Nullable<string>;
  downloadArtifact: (artifactType: ArtifactType, artifactKey?: string) => Promise<void>;
}

type UseArtifactLoader = (
  load: (artifactType: ArtifactType, artifactKey?: string) => Nullable<Promise<ResponseArtifact>>,
) => HookReturn;

export const useArtifactLoader: UseArtifactLoader = (load) => {
  const [isArtifactLoading, setIsArtifactLoading] = useState<HookReturn['isArtifactLoading']>(false);
  const [currentArtifactTypeLoading, setCurrentArtifactTypeLoading] =
    useState<HookReturn['currentArtifactTypeLoading']>(null);
  const [currentArtifactExtendLoading, setCurrentArtifactExtendLoading] =
    useState<HookReturn['currentArtifactExtendLoading']>(null);

  const downloadArtifact: HookReturn['downloadArtifact'] = async (artifactType, artifactKey) => {
    setIsArtifactLoading(true);
    setCurrentArtifactTypeLoading(artifactType);
    artifactKey && setCurrentArtifactExtendLoading(artifactKey);

    await load(artifactType, artifactKey)
      ?.then(({ fileName, file }) => {
        saveFileFromBlob(fileName ?? '', file);
      })
      .catch(console.error)
      .finally(() => {
        setIsArtifactLoading(false);
        setCurrentArtifactTypeLoading(null);
        setCurrentArtifactExtendLoading(null);
      });
  };

  return {
    isArtifactLoading,
    currentArtifactTypeLoading,
    currentArtifactExtendLoading,
    downloadArtifact,
  };
};
